import './main';
// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from 'swiper/swiper-bundle.js';
// import Swiper and modules styles

import "swiper/swiper.scss";
import "swiper/modules/pagination/pagination.scss";
import "swiper/modules/navigation/navigation.scss";

import PhotoSwipeLightbox from '../../static/assets/PhotoSwipe/umd/photoswipe-lightbox.umd.min.js';
import PhotoSwipe from '../../static/assets/PhotoSwipe/umd/photoswipe.umd.min.js';

window.addEventListener('DOMContentLoaded', () => {

    /*
    const lightbox = new PhotoSwipeLightbox({
      gallery: '#my-gallery',
      children: 'a',
      pswpModule: () => import('photoswipe')
    });
    lightbox.init();
    */

    const lightbox = new PhotoSwipeLightbox({
      gallery: '#my-gallery',
      children: 'a',
      pswpModule: PhotoSwipe
    });

    lightbox.init();

    const swiper = new Swiper('.swiper', {
        // Optional parameters
        direction: 'horizontal',
        slidesPerView: "auto",
        loop: false,
      
        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      
        // And if we need scrollbar
        scrollbar: {
          el: '.swiper-scrollbar',
        },
    });    

});

